/* Interface texts in three languages. "**text**" is rendered bold. */

const T = {
    ru: {
        langName: "Русский",
        nav: { services: "Услуги", ai: "ИИ для бизнеса", process: "Как работаем", gps: "GPS и камеры", contact: "Контакты" },
        cta: "Оставить заявку",
        menu: "Меню",
        home: "Главная",

        short: {
            home: "Главная", websites: "Разработка сайтов", landing: "Лендинги", ecommerce: "Интернет-магазины",
            software: "Программы на заказ", pos: "POS-системы", android: "Android-приложения", crm: "CRM-системы",
            erp: "ERP-системы", bitrix24: "Bitrix24", amocrm: "amoCRM", booking: "Онлайн-бронирование",
            integrations: "Интеграции и API", payments: "Payme, Click, Uzum", wialon: "Интеграция Wialon",
            telegram: "Telegram-боты", ai: "ИИ для бизнеса", automation: "Автоматизация", arduino: "Arduino и IoT", seo: "SEO-продвижение",
            support: "Поддержка", nukus_web: "Сайты в Нукусе", nukus_software: "Программы в Нукусе",
            nukus_crm: "CRM и ERP в Нукусе", nukus_seo: "SEO в Нукусе", karakalpakstan: "Каракалпакстан",
            urgench: "Ургенч", khorezm: "Хорезм", about: "О компании", contacts: "Контакты",
        },

        hero: {
            badge: "IT-студия · Нукус",
            lead: "Делаем сайты, программы, Android-приложения, CRM и ERP, подключаем Bitrix24 и amoCRM, связываем системы через API и внедряем ИИ-агентов — чтобы ваш бизнес работал быстрее и без лишней ручной работы.",
            ctaPrimary: "Обсудить проект",
            ctaSecondary: "Все услуги",
            trust: ["Под ключ", "RU · UZ · EN", "Поддержка после запуска"],
            codeComment: "// → заявки, продажи и отчёты — автоматически",
            toast: "Новая заявка с сайта",
            toastSub: "передана в CRM и Telegram",
        },

        stack: "Технологии и сервисы, с которыми работаем",

        focus: {
            eyebrow: "Направление",
            eyebrowCity: "Регион",
            includes: "Что входит",
            cta: "Обсудить задачу",
            related: "Смотрите также",
        },

        services: {
            eyebrow: "Услуги",
            title: "Всё, что нужно бизнесу в цифре — в одной команде",
            text: "От сайта и Telegram-бота до CRM, ERP и ИИ-агентов. Можно заказать одну услугу или доверить нам всю цифровизацию компании.",
            more: "Подробнее",
            ctaTitle: "Не нашли свою задачу?",
            ctaText: "Опишите её — подскажем решение, даже если её нет в списке.",
            items: {
                web: ["Сайты и веб-сервисы", "Корпоративные сайты, лендинги, интернет-магазины и личные кабинеты на React."],
                software: ["Программы на заказ", "Учёт, склад, касса и десктоп-программы для Windows под ваши процессы."],
                android: ["Android-приложения", "Приложения для клиентов, курьеров, агентов и сотрудников, в том числе офлайн."],
                crm: ["CRM и ERP-системы", "Собственные системы для продаж, производства, склада и логистики."],
                bitrix: ["Bitrix24 и amoCRM", "Открытие аккаунтов, настройка воронок, роботов, интеграций и обучение."],
                booking: ["Системы бронирования", "Онлайн-запись для гостиниц, клиник, салонов и сервисов с предоплатой."],
                integrations: ["Интеграции и API", "Сайт, CRM, 1С, банки, Payme, Click и Uzum — данные передаются сами."],
                wialon: ["Интеграции Wialon", "Данные GPS-мониторинга в CRM, ERP и 1С, свои отчёты и боты."],
                bots: ["Telegram-боты", "Заказы, запись, оплата, поддержка клиентов и уведомления сотрудникам."],
                ai: ["ИИ для бизнеса", "ИИ-агенты, умные чат-боты и автоматизация рутины в компании."],
                iot: ["Arduino и IoT", "Устройства на Arduino и ESP32: датчики, реле, автоматика и связь с ботом и сервером."],
                seo: ["SEO-продвижение", "Вывод сайта в Google и Яндекс по запросам вашего города и услуг."],
                support: ["Поддержка и сервера", "Хостинг, домены, SSL, резервные копии и доработки после запуска."],
            },
        },

        ai: {
            eyebrow: "ИИ для бизнеса",
            title: "Искусственный интеллект, который работает на вашу компанию",
            text: "Внедряем ИИ туда, где он экономит время и деньги: общение с клиентами, обработка заявок, документы и отчёты. Агенты говорят на русском и узбекском и работают круглосуточно.",
            cards: [
                ["ИИ-агенты", "Принимают заявки, отвечают клиентам, записывают на услуги и заносят всё в CRM."],
                ["Умные чат-боты", "Telegram-бот и чат на сайте, которые понимают обычную речь, а не только кнопки."],
                ["Автоматизация", "Документы по шаблону, сводки руководителю, контроль задач — без ручной работы."],
                ["На ваших данных", "Обучаем ИИ на ваших прайсах, регламентах и базе знаний, чтобы ответы были точными."],
            ],
            more: "Подробнее об ИИ",
            status: "ИИ-агент · онлайн",
            chat: [
                ["user", "Здравствуйте! Можно записаться на завтра?"],
                ["bot", "Здравствуйте! Завтра свободно 10:00, 14:30 и 17:00. Какое время вам удобно?"],
                ["user", "14:30"],
                ["bot", "Готово ✅ Записал вас на завтра в 14:30. Напомню за час до визита."],
            ],
            system: "Заявка создана в CRM",
        },

        process: {
            eyebrow: "Как работаем",
            title: "Понятный путь от идеи до работающей системы",
            steps: [
                ["Заявка и разговор", "Слушаем задачу, задаём вопросы и предлагаем варианты решения."],
                ["Анализ и ТЗ", "Описываем, что именно будет сделано, сроки и стоимость — до начала работ."],
                ["Дизайн и прототип", "Показываем, как будет выглядеть и работать система, и согласуем с вами."],
                ["Разработка и тесты", "Пишем код, подключаем интеграции и проверяем всё на реальных сценариях."],
                ["Запуск и поддержка", "Внедряем, обучаем сотрудников и остаёмся на связи после запуска."],
            ],
        },

        integr: {
            eyebrow: "Интеграции",
            title: "Соединяем сервисы, которыми вы уже пользуетесь",
            text: "Bitrix24, amoCRM, 1С, Wialon, Telegram, платёжные системы и ИИ — всё работает вместе, а данные передаются автоматически.",
            more: "Об интеграциях",
        },

        gps: {
            eyebrow: "Отдельное направление",
            title: "GPS-мониторинг транспорта и видеонаблюдение",
            text: "Контроль транспорта, расхода топлива, установка трекеров Teltonika и камер HOWEN, Hikvision и Dahua — этим направлением занимается наш отдельный сайт.",
            items: ["GPS/ГЛОНАСС-мониторинг на Wialon", "Контроль топлива и датчики уровня", "Видеонаблюдение для транспорта и объектов", "Установка и обслуживание по Каракалпакстану и Хорезму"],
            cta: "Перейти на gps.allsystems.uz",
        },

        geo: {
            eyebrow: "География",
            title: "Офис в Нукусе — работаем по всему региону",
            text: "Встречаемся лично в Нукусе, выезжаем для внедрения по Каракалпакстану и Хорезму, а удалённо работаем с клиентами по всему Узбекистану.",
            cities: [
                ["nukus_web", "Нукус", "Офис, встречи и внедрение на месте"],
                ["karakalpakstan", "Каракалпакстан", "Ходжейли, Чимбай, Кунград, Турткуль, Беруни"],
                ["urgench", "Ургенч", "Сайты, CRM и боты для бизнеса Ургенча"],
                ["khorezm", "Хорезм", "Хива, Ханка, Шават и другие районы"],
            ],
        },

        why: {
            eyebrow: "Почему ALL SYSTEMS",
            title: "Делаем так, чтобы система реально работала",
            items: [
                ["Рядом с вами", "Офис в Нукусе: можно встретиться, показать процессы и обсудить всё лично."],
                ["Полный цикл", "Анализ, дизайн, разработка, сервер, интеграции и поддержка — одна команда."],
                ["Сильны в интеграциях", "Связываем CRM, 1С, Wialon, платежи и мессенджеры в одну систему."],
                ["Знаем транспорт", "Свой опыт в GPS-мониторинге и логистике — понимаем процессы автопарков."],
                ["Прямая связь с разработчиком", "Общаетесь напрямую с тем, кто пишет код, — без менеджеров-посредников и испорченного телефона."],
                ["Не бросаем после запуска", "Обучаем сотрудников, поддерживаем и развиваем систему дальше."],
            ],
        },

        faq: {
            eyebrow: "Вопросы и ответы",
            title: "Частые вопросы",
            items: [
                ["Сколько стоит разработка сайта или программы?", "Стоимость зависит от задачи: количества страниц, функций и интеграций. Оставьте заявку — уточним детали и назовём цену и сроки до начала работ."],
                ["Сколько времени занимает разработка?", "Лендинг можно запустить быстро, корпоративный сайт и Telegram-бот — дольше, а CRM, ERP и мобильные приложения делаем поэтапно. Точный срок фиксируем после обсуждения задачи."],
                ["Вы работаете только в Нукусе?", "Офис находится в Нукусе. Работаем по всему Каракалпакстану и Хорезму (Ургенч, Хива), а удалённо — с клиентами по всему Узбекистану."],
                ["Можете открыть и настроить Bitrix24 или amoCRM?", "Да. Регистрируем аккаунт, помогаем выбрать тариф, настраиваем воронки, роботов и интеграции с сайтом, Telegram и телефонией, переносим базу и обучаем сотрудников."],
                ["Что значит «внедрить ИИ в бизнес»?", "Это ИИ-агенты и чат-боты, которые отвечают клиентам, принимают заявки, работают с документами и CRM. Мы находим рутинные задачи в компании и автоматизируем их с помощью ИИ."],
                ["Делаете интеграции с Wialon?", "Да. Забираем данные через Wialon API и передаём их в CRM, ERP или 1С, делаем свои отчёты, дашборды и Telegram-уведомления для диспетчеров и руководителей."],
                ["Подключаете оплату Payme, Click и Uzum?", "Да, интегрируем онлайн-оплату в сайты, интернет-магазины, Telegram-боты и приложения с автоматическим подтверждением заказа."],
                ["Можно ли вывести сайт в Google по запросам Нукуса?", "Да. Делаем страницы под городские запросы, оформляем компанию в Google и Яндекс Картах и настраиваем Search Console и Вебмастер."],
                ["Делаете устройства на Arduino?", "Да. Разрабатываем и программируем устройства на Arduino и ESP32: датчики, управление реле и оборудованием, передача данных на сервер и уведомления в Telegram."],
                ["Будет ли поддержка после запуска?", "Да. Берём на поддержку сайты, программы и серверы: исправляем ошибки, делаем резервные копии и дорабатываем систему по новым задачам."],
            ],
        },

        contact: {
            eyebrow: "Заявка",
            title: "Расскажите о задаче — предложим решение",
            text: "Опишите, что нужно сделать. Свяжемся в рабочее время, уточним детали и назовём сроки и стоимость.",
            labels: { name: "Ваше имя", phone: "Телефон", service: "Услуга", message: "Коротко о задаче" },
            placeholders: { name: "Как к вам обращаться", phone: "+998 __ ___ __ __", message: "Например: нужен сайт с каталогом и заявками в Telegram" },
            other: "Другое",
            send: "Отправить заявку",
            sending: "Отправляем…",
            consent: "Нажимая кнопку, вы соглашаетесь на обработку персональных данных.",
            successTitle: "Заявка отправлена!",
            successText: "Мы свяжемся с вами в рабочее время.",
            again: "Отправить ещё одну",
            error: "Не удалось отправить. Позвоните нам: +998 93 099 60 60",
            phoneTitle: "Телефон",
            emailTitle: "E-mail",
            addressTitle: "Адрес",
            addressValue: "г. Нукус, Республика Каракалпакстан",
            hours: "Режим работы",
            days: [["Пн–Пт", "09:00–18:00"], ["Сб", "09:00–12:30"], ["Вс", "Выходной"]],
        },

        footer: {
            about: "IT-студия из Нукуса: сайты, программы, CRM/ERP, интеграции, Telegram-боты и ИИ для бизнеса.",
            services: "Услуги",
            more: "Направления",
            regions: "Регионы",
            company: "Компания",
            gps: "GPS-мониторинг и камеры",
            copy: "ALL SYSTEMS. Все права защищены.",
        },
    },

    uz: {
        langName: "O‘zbekcha",
        nav: { services: "Xizmatlar", ai: "Biznes uchun AI", process: "Qanday ishlaymiz", gps: "GPS va kameralar", contact: "Kontaktlar" },
        cta: "Ariza qoldirish",
        menu: "Menyu",
        home: "Bosh sahifa",

        short: {
            home: "Bosh sahifa", websites: "Sayt yaratish", landing: "Landinglar", ecommerce: "Internet-do‘konlar",
            software: "Buyurtma dasturlar", pos: "POS-tizimlar", android: "Android ilovalar", crm: "CRM-tizimlar",
            erp: "ERP-tizimlar", bitrix24: "Bitrix24", amocrm: "amoCRM", booking: "Onlayn bron",
            integrations: "Integratsiya va API", payments: "Payme, Click, Uzum", wialon: "Wialon integratsiyasi",
            telegram: "Telegram-botlar", ai: "Biznes uchun AI", automation: "Avtomatlashtirish", arduino: "Arduino va IoT", seo: "SEO",
            support: "Qo‘llab-quvvatlash", nukus_web: "Nukusda saytlar", nukus_software: "Nukusda dasturlar",
            nukus_crm: "Nukusda CRM va ERP", nukus_seo: "Nukusda SEO", karakalpakstan: "Qoraqalpog‘iston",
            urgench: "Urganch", khorezm: "Xorazm", about: "Kompaniya haqida", contacts: "Kontaktlar",
        },

        hero: {
            badge: "IT-studiya · Nukus",
            lead: "Saytlar, dasturlar, Android ilovalar, CRM va ERP yaratamiz, Bitrix24 va amoCRM’ni ulaymiz, tizimlarni API orqali bog‘laymiz va AI-agentlarni joriy etamiz — biznesingiz tezroq va ortiqcha qo‘l mehnatisiz ishlashi uchun.",
            ctaPrimary: "Loyihani muhokama qilish",
            ctaSecondary: "Barcha xizmatlar",
            trust: ["Kalit topshirish", "RU · UZ · EN", "Ishga tushirgandan keyin yordam"],
            codeComment: "// → arizalar, savdo va hisobotlar — avtomatik",
            toast: "Saytdan yangi ariza",
            toastSub: "CRM va Telegramga uzatildi",
        },

        stack: "Biz ishlaydigan texnologiyalar va servislar",

        focus: {
            eyebrow: "Yo‘nalish",
            eyebrowCity: "Hudud",
            includes: "Nimalar kiradi",
            cta: "Vazifani muhokama qilish",
            related: "Shuningdek qarang",
        },

        services: {
            eyebrow: "Xizmatlar",
            title: "Biznesni raqamlashtirish uchun hamma narsa — bitta jamoada",
            text: "Sayt va Telegram-botdan CRM, ERP va AI-agentlargacha. Bitta xizmatni buyurtma qilishingiz yoki kompaniyaning butun raqamlashtirishini bizga ishonib topshirishingiz mumkin.",
            more: "Batafsil",
            ctaTitle: "Vazifangizni topmadingizmi?",
            ctaText: "Uni yozib qoldiring — ro‘yxatda bo‘lmasa ham yechim taklif qilamiz.",
            items: {
                web: ["Saytlar va veb-servislar", "React’da korporativ saytlar, landinglar, internet-do‘konlar va shaxsiy kabinetlar."],
                software: ["Buyurtma dasturlar", "Jarayonlaringiz uchun hisob, ombor, kassa va Windows dasturlari."],
                android: ["Android ilovalar", "Mijozlar, kuryerlar, agentlar va xodimlar uchun ilovalar, jumladan oflayn."],
                crm: ["CRM va ERP-tizimlar", "Savdo, ishlab chiqarish, ombor va logistika uchun o‘z tizimlarimiz."],
                bitrix: ["Bitrix24 va amoCRM", "Akkaunt ochish, voronka, robotlar, integratsiyalarni sozlash va o‘qitish."],
                booking: ["Bron tizimlari", "Mehmonxona, klinika, salon va servislar uchun oldindan to‘lovli onlayn yozilish."],
                integrations: ["Integratsiya va API", "Sayt, CRM, 1C, banklar, Payme, Click va Uzum — ma’lumotlar o‘zi uzatiladi."],
                wialon: ["Wialon integratsiyasi", "GPS-monitoring ma’lumotlari CRM, ERP va 1Cda, o‘z hisobot va botlar."],
                bots: ["Telegram-botlar", "Buyurtma, yozilish, to‘lov, mijozlarni qo‘llab-quvvatlash va bildirishnomalar."],
                ai: ["Biznes uchun AI", "AI-agentlar, aqlli chat-botlar va kompaniyadagi rutinani avtomatlashtirish."],
                iot: ["Arduino va IoT", "Arduino va ESP32’da qurilmalar: datchiklar, rele, avtomatika, bot va server bilan aloqa."],
                seo: ["SEO", "Saytni shahringiz va xizmatlaringiz so‘rovlari bo‘yicha Google va Yandexga chiqarish."],
                support: ["Yordam va serverlar", "Hosting, domenlar, SSL, zaxira nusxalar va ishga tushirgandan keyingi qo‘shimchalar."],
            },
        },

        ai: {
            eyebrow: "Biznes uchun AI",
            title: "Kompaniyangiz uchun ishlaydigan sun’iy intellekt",
            text: "AIni vaqt va pulni tejaydigan joyga joriy etamiz: mijozlar bilan muloqot, arizalarni qayta ishlash, hujjatlar va hisobotlar. Agentlar rus va o‘zbek tillarida gaplashadi va kecha-kunduz ishlaydi.",
            cards: [
                ["AI-agentlar", "Arizalarni qabul qiladi, mijozlarga javob beradi, xizmatlarga yozadi va hammasini CRMga kiritadi."],
                ["Aqlli chat-botlar", "Faqat tugmalarni emas, oddiy nutqni tushunadigan Telegram-bot va saytdagi chat."],
                ["Avtomatlashtirish", "Shablon bo‘yicha hujjatlar, rahbarga hisobotlar, vazifalar nazorati — qo‘l mehnatisiz."],
                ["Ma’lumotlaringiz asosida", "Javoblar aniq bo‘lishi uchun AIni narxlar, reglamentlar va bilim bazangizda o‘qitamiz."],
            ],
            more: "AI haqida batafsil",
            status: "AI-agent · onlayn",
            chat: [
                ["user", "Assalomu alaykum! Ertaga yozilsam bo‘ladimi?"],
                ["bot", "Va alaykum assalom! Ertaga 10:00, 14:30 va 17:00 bo‘sh. Qaysi vaqt qulay?"],
                ["user", "14:30"],
                ["bot", "Tayyor ✅ Sizni ertaga 14:30 ga yozdim. Tashrifdan bir soat oldin eslataman."],
            ],
            system: "Ariza CRMda yaratildi",
        },

        process: {
            eyebrow: "Qanday ishlaymiz",
            title: "G‘oyadan ishlaydigan tizimgacha tushunarli yo‘l",
            steps: [
                ["Ariza va suhbat", "Vazifani tinglaymiz, savollar beramiz va yechim variantlarini taklif qilamiz."],
                ["Tahlil va TT", "Aynan nima qilinishini, muddat va narxni — ish boshlanishidan oldin yozib beramiz."],
                ["Dizayn va prototip", "Tizim qanday ko‘rinishi va ishlashini ko‘rsatamiz va siz bilan kelishamiz."],
                ["Ishlab chiqish va test", "Kod yozamiz, integratsiyalarni ulaymiz va hammasini real ssenariylarda tekshiramiz."],
                ["Ishga tushirish va yordam", "Joriy etamiz, xodimlarni o‘qitamiz va ishga tushirgandan keyin aloqada qolamiz."],
            ],
        },

        integr: {
            eyebrow: "Integratsiyalar",
            title: "Siz allaqachon foydalanayotgan servislarni bog‘laymiz",
            text: "Bitrix24, amoCRM, 1C, Wialon, Telegram, to‘lov tizimlari va AI — hammasi birga ishlaydi, ma’lumotlar esa avtomatik uzatiladi.",
            more: "Integratsiyalar haqida",
        },

        gps: {
            eyebrow: "Alohida yo‘nalish",
            title: "Transport GPS-monitoringi va videokuzatuv",
            text: "Transport va yoqilg‘i sarfini nazorat qilish, Teltonika trekerlari hamda HOWEN, Hikvision va Dahua kameralarini o‘rnatish — bu yo‘nalish bilan alohida saytimiz shug‘ullanadi.",
            items: ["Wialon’da GPS/GLONASS-monitoring", "Yoqilg‘i nazorati va sath datchiklari", "Transport va obyektlar uchun videokuzatuv", "Qoraqalpog‘iston va Xorazm bo‘ylab o‘rnatish va xizmat"],
            cta: "gps.allsystems.uz saytiga o‘tish",
        },

        geo: {
            eyebrow: "Geografiya",
            title: "Ofis Nukusda — butun hudud bo‘ylab ishlaymiz",
            text: "Nukusda shaxsan uchrashamiz, joriy etish uchun Qoraqalpog‘iston va Xorazm bo‘ylab boramiz, masofadan esa butun O‘zbekiston bo‘ylab mijozlar bilan ishlaymiz.",
            cities: [
                ["nukus_web", "Nukus", "Ofis, uchrashuvlar va joyida joriy etish"],
                ["karakalpakstan", "Qoraqalpog‘iston", "Xo‘jayli, Chimboy, Qo‘ng‘irot, To‘rtko‘l, Beruniy"],
                ["urgench", "Urganch", "Urganch biznesi uchun saytlar, CRM va botlar"],
                ["khorezm", "Xorazm", "Xiva, Xonqa, Shovot va boshqa tumanlar"],
            ],
        },

        why: {
            eyebrow: "Nega ALL SYSTEMS",
            title: "Tizim haqiqatan ishlashi uchun qilamiz",
            items: [
                ["Yoningizdamiz", "Ofis Nukusda: uchrashib, jarayonlarni ko‘rsatib, hammasini shaxsan muhokama qilish mumkin."],
                ["To‘liq sikl", "Tahlil, dizayn, ishlab chiqish, server, integratsiya va yordam — bitta jamoa."],
                ["Integratsiyada kuchlimiz", "CRM, 1C, Wialon, to‘lovlar va messenjerlarni bitta tizimga bog‘laymiz."],
                ["Transportni bilamiz", "GPS-monitoring va logistikada o‘z tajribamiz — avtoparklar jarayonlarini tushunamiz."],
                ["Dasturchi bilan to‘g‘ridan-to‘g‘ri aloqa", "Kod yozayotgan odam bilan bevosita gaplashasiz — vositachi menejerlarsiz va noto‘g‘ri tushunishlarsiz."],
                ["Tashlab ketmaymiz", "Xodimlarni o‘qitamiz, tizimni qo‘llab-quvvatlaymiz va rivojlantiramiz."],
            ],
        },

        faq: {
            eyebrow: "Savol-javoblar",
            title: "Ko‘p beriladigan savollar",
            items: [
                ["Sayt yoki dastur yaratish qancha turadi?", "Narx vazifaga bog‘liq: sahifalar, funksiyalar va integratsiyalar soni. Ariza qoldiring — tafsilotlarni aniqlab, ish boshlanishidan oldin narx va muddatni aytamiz."],
                ["Ishlab chiqish qancha vaqt oladi?", "Landingni tez ishga tushirish mumkin, korporativ sayt va Telegram-bot ko‘proq vaqt oladi, CRM, ERP va mobil ilovalarni esa bosqichma-bosqich qilamiz. Aniq muddatni vazifani muhokama qilgandan keyin belgilaymiz."],
                ["Faqat Nukusda ishlaysizmi?", "Ofis Nukusda. Butun Qoraqalpog‘iston va Xorazm (Urganch, Xiva) bo‘ylab, masofadan esa butun O‘zbekiston bo‘ylab ishlaymiz."],
                ["Bitrix24 yoki amoCRM’ni ochib, sozlab bera olasizmi?", "Ha. Akkauntni ro‘yxatdan o‘tkazamiz, tarif tanlashga yordam beramiz, voronkalar, robotlar va sayt, Telegram, telefoniya bilan integratsiyani sozlaymiz, bazani ko‘chirib, xodimlarni o‘qitamiz."],
                ["«Biznesga AI joriy etish» nima degani?", "Bu mijozlarga javob beradigan, arizalarni qabul qiladigan, hujjatlar va CRM bilan ishlaydigan AI-agentlar va chat-botlar. Kompaniyadagi rutina vazifalarni topib, ularni AI yordamida avtomatlashtiramiz."],
                ["Wialon bilan integratsiya qilasizmi?", "Ha. Wialon API orqali ma’lumotlarni olib, CRM, ERP yoki 1Cga uzatamiz, dispetcher va rahbarlar uchun o‘z hisobotlari, dashbordlar va Telegram-bildirishnomalar yaratamiz."],
                ["Payme, Click va Uzum to‘lovini ulaysizmi?", "Ha, onlayn to‘lovni saytlar, internet-do‘konlar, Telegram-botlar va ilovalarga buyurtmani avtomatik tasdiqlash bilan integratsiya qilamiz."],
                ["Saytni Nukus so‘rovlari bo‘yicha Google’ga chiqarish mumkinmi?", "Ha. Shahar so‘rovlari uchun sahifalar yaratamiz, kompaniyani Google va Yandex Xaritalarida rasmiylashtiramiz, Search Console va Vebmasterni sozlaymiz."],
                ["Arduino’da qurilmalar yasaysizmi?", "Ha. Arduino va ESP32’da qurilmalarni ishlab chiqamiz va dasturlaymiz: datchiklar, rele va uskunalarni boshqarish, ma’lumotlarni serverga uzatish va Telegramda bildirishnomalar."],
                ["Ishga tushirgandan keyin yordam bo‘ladimi?", "Ha. Saytlar, dasturlar va serverlarni qo‘llab-quvvatlashga olamiz: xatolarni tuzatamiz, zaxira nusxa olamiz va tizimni yangi vazifalar bo‘yicha rivojlantiramiz."],
            ],
        },

        contact: {
            eyebrow: "Ariza",
            title: "Vazifa haqida aytib bering — yechim taklif qilamiz",
            text: "Nima qilish kerakligini yozing. Ish vaqtida bog‘lanamiz, tafsilotlarni aniqlab, muddat va narxni aytamiz.",
            labels: { name: "Ismingiz", phone: "Telefon", service: "Xizmat", message: "Vazifa haqida qisqacha" },
            placeholders: { name: "Sizga qanday murojaat qilaylik", phone: "+998 __ ___ __ __", message: "Masalan: katalogli va Telegramga arizali sayt kerak" },
            other: "Boshqa",
            send: "Ariza yuborish",
            sending: "Yuborilmoqda…",
            consent: "Tugmani bosib, shaxsiy ma’lumotlarni qayta ishlashga rozilik bildirasiz.",
            successTitle: "Ariza yuborildi!",
            successText: "Ish vaqtida siz bilan bog‘lanamiz.",
            again: "Yana bitta yuborish",
            error: "Yuborib bo‘lmadi. Bizga qo‘ng‘iroq qiling: +998 93 099 60 60",
            phoneTitle: "Telefon",
            emailTitle: "E-mail",
            addressTitle: "Manzil",
            addressValue: "Nukus shahri, Qoraqalpog‘iston Respublikasi",
            hours: "Ish vaqti",
            days: [["Du–Ju", "09:00–18:00"], ["Sha", "09:00–12:30"], ["Ya", "Dam olish kuni"]],
        },

        footer: {
            about: "Nukusdagi IT-studiya: saytlar, dasturlar, CRM/ERP, integratsiyalar, Telegram-botlar va biznes uchun AI.",
            services: "Xizmatlar",
            more: "Yo‘nalishlar",
            regions: "Hududlar",
            company: "Kompaniya",
            gps: "GPS-monitoring va kameralar",
            copy: "ALL SYSTEMS. Barcha huquqlar himoyalangan.",
        },
    },

    en: {
        langName: "English",
        nav: { services: "Services", ai: "AI for business", process: "How we work", gps: "GPS & cameras", contact: "Contact" },
        cta: "Get in touch",
        menu: "Menu",
        home: "Home",

        short: {
            home: "Home", websites: "Website development", landing: "Landing pages", ecommerce: "Online stores",
            software: "Custom software", pos: "POS systems", android: "Android apps", crm: "CRM systems",
            erp: "ERP systems", bitrix24: "Bitrix24", amocrm: "amoCRM", booking: "Online booking",
            integrations: "Integrations & API", payments: "Payme, Click, Uzum", wialon: "Wialon integration",
            telegram: "Telegram bots", ai: "AI for business", automation: "Automation", arduino: "Arduino & IoT", seo: "SEO",
            support: "Support", nukus_web: "Websites in Nukus", nukus_software: "Software in Nukus",
            nukus_crm: "CRM & ERP in Nukus", nukus_seo: "SEO in Nukus", karakalpakstan: "Karakalpakstan",
            urgench: "Urgench", khorezm: "Khorezm", about: "About us", contacts: "Contact",
        },

        hero: {
            badge: "IT studio · Nukus",
            lead: "We build websites, software, Android apps, CRMs and ERPs, set up Bitrix24 and amoCRM, connect systems via APIs and deploy AI agents, so your business runs faster with less manual work.",
            ctaPrimary: "Discuss a project",
            ctaSecondary: "All services",
            trust: ["Turnkey", "RU · UZ · EN", "Support after launch"],
            codeComment: "// → leads, sales and reports: automated",
            toast: "New lead from the website",
            toastSub: "sent to CRM and Telegram",
        },

        stack: "Technologies and services we work with",

        focus: {
            eyebrow: "Service",
            eyebrowCity: "Region",
            includes: "What's included",
            cta: "Discuss your task",
            related: "See also",
        },

        services: {
            eyebrow: "Services",
            title: "Everything your business needs to go digital, in one team",
            text: "From a website and a Telegram bot to CRM, ERP and AI agents. Order a single service or trust us with your company's whole digital transformation.",
            more: "Learn more",
            ctaTitle: "Don't see your task?",
            ctaText: "Describe it, and we'll suggest a solution even if it's not on the list.",
            items: {
                web: ["Websites & web services", "Corporate websites, landing pages, online stores and client portals built with React."],
                software: ["Custom software", "Accounting, inventory, POS and Windows desktop apps built around your processes."],
                android: ["Android apps", "Apps for customers, couriers, sales agents and staff, including offline mode."],
                crm: ["CRM & ERP systems", "Custom systems for sales, production, inventory and logistics."],
                bitrix: ["Bitrix24 & amoCRM", "Account setup, pipelines, automation, integrations and training."],
                booking: ["Booking systems", "Online booking for hotels, clinics, salons and services, with prepayment."],
                integrations: ["Integrations & API", "Website, CRM, 1C, banks, Payme, Click and Uzum, with data flowing on its own."],
                wialon: ["Wialon integrations", "GPS tracking data in your CRM, ERP and 1C, plus custom reports and bots."],
                bots: ["Telegram bots", "Orders, bookings, payments, customer support and staff alerts."],
                ai: ["AI for business", "AI agents, smart chatbots and automation of routine work."],
                iot: ["Arduino & IoT", "Devices on Arduino and ESP32: sensors, relays and automation, linked to bots and servers."],
                seo: ["SEO", "Ranking your website in Google and Yandex for your city and services."],
                support: ["Support & servers", "Hosting, domains, SSL, backups and improvements after launch."],
            },
        },

        ai: {
            eyebrow: "AI for business",
            title: "Artificial intelligence that works for your company",
            text: "We bring AI in where it saves time and money: customer communication, lead handling, documents and reports. Our agents speak Russian and Uzbek and work around the clock.",
            cards: [
                ["AI agents", "Take requests, answer customers, book appointments and log everything in the CRM."],
                ["Smart chatbots", "A Telegram bot and website chat that understand plain language, not just buttons."],
                ["Automation", "Documents from templates, summaries for management, task tracking, with no manual work."],
                ["Trained on your data", "We train the AI on your price lists, procedures and knowledge base so its answers are accurate."],
            ],
            more: "More about AI",
            status: "AI agent · online",
            chat: [
                ["user", "Hi! Can I book an appointment for tomorrow?"],
                ["bot", "Hi! Tomorrow we have 10:00, 14:30 and 17:00 available. Which works for you?"],
                ["user", "14:30"],
                ["bot", "Done ✅ You're booked for tomorrow at 14:30. I'll remind you an hour before."],
            ],
            system: "Lead created in the CRM",
        },

        process: {
            eyebrow: "How we work",
            title: "A clear path from idea to a working system",
            steps: [
                ["Request & call", "We listen to the task, ask questions and suggest possible solutions."],
                ["Analysis & spec", "We write down exactly what will be built, the timeline and the cost before work starts."],
                ["Design & prototype", "We show how the system will look and work and agree on it with you."],
                ["Development & testing", "We write the code, connect integrations and test everything on real scenarios."],
                ["Launch & support", "We roll it out, train your staff and stay in touch after launch."],
            ],
        },

        integr: {
            eyebrow: "Integrations",
            title: "We connect the services you already use",
            text: "Bitrix24, amoCRM, 1C, Wialon, Telegram, payment systems and AI all work together, and data is passed along automatically.",
            more: "About integrations",
        },

        gps: {
            eyebrow: "A separate line of business",
            title: "GPS fleet tracking and video surveillance",
            text: "Fleet and fuel monitoring, installation of Teltonika trackers and HOWEN, Hikvision and Dahua cameras. This side of our work has its own website.",
            items: ["GPS/GLONASS tracking on Wialon", "Fuel control and level sensors", "Video surveillance for vehicles and sites", "Installation and service across Karakalpakstan and Khorezm"],
            cta: "Go to gps.allsystems.uz",
        },

        geo: {
            eyebrow: "Where we work",
            title: "Office in Nukus, working across the region",
            text: "We meet in person in Nukus, travel across Karakalpakstan and Khorezm for rollouts, and work remotely with clients all over Uzbekistan.",
            cities: [
                ["nukus_web", "Nukus", "Office, meetings and on-site rollout"],
                ["karakalpakstan", "Karakalpakstan", "Khojeyli, Chimbay, Kungrad, Turtkul, Beruni"],
                ["urgench", "Urgench", "Websites, CRMs and bots for Urgench businesses"],
                ["khorezm", "Khorezm", "Khiva, Khanka, Shavat and other districts"],
            ],
        },

        why: {
            eyebrow: "Why ALL SYSTEMS",
            title: "We make sure the system actually works",
            items: [
                ["Close to you", "Our office is in Nukus, so we can meet, look at your processes and discuss everything in person."],
                ["Full cycle", "Analysis, design, development, servers, integrations and support from one team."],
                ["Strong at integrations", "We connect CRM, 1C, Wialon, payments and messengers into one system."],
                ["We know transport", "Hands-on experience in GPS tracking and logistics, so we understand how fleets work."],
                ["Direct line to the developer", "You talk directly to the person writing the code, with no middle managers and nothing lost in translation."],
                ["We stay after launch", "We train your staff, support the system and keep developing it."],
            ],
        },

        faq: {
            eyebrow: "Q&A",
            title: "Frequently asked questions",
            items: [
                ["How much does a website or software cost?", "It depends on the task: the number of pages, features and integrations. Send a request and we'll clarify the details and give you the price and timeline before any work starts."],
                ["How long does development take?", "A landing page can launch quickly, a corporate website or Telegram bot takes longer, and CRMs, ERPs and mobile apps are built in stages. We fix the exact timeline after discussing the task."],
                ["Do you only work in Nukus?", "Our office is in Nukus. We work across Karakalpakstan and Khorezm (Urgench, Khiva), and remotely with clients all over Uzbekistan."],
                ["Can you open and set up Bitrix24 or amoCRM?", "Yes. We register the account, help choose a plan, set up pipelines, automation and integrations with your website, Telegram and telephony, migrate your data and train your staff."],
                ["What does \"bringing AI into a business\" mean?", "It means AI agents and chatbots that answer customers, take requests and work with documents and the CRM. We find routine tasks in your company and automate them with AI."],
                ["Do you do Wialon integrations?", "Yes. We pull data through the Wialon API and pass it to your CRM, ERP or 1C, and build custom reports, dashboards and Telegram alerts for dispatchers and managers."],
                ["Do you connect Payme, Click and Uzum payments?", "Yes. We integrate online payments into websites, online stores, Telegram bots and apps, with automatic order confirmation."],
                ["Can you get a website ranking in Google for Nukus searches?", "Yes. We create pages for city searches, set up your company on Google and Yandex Maps, and configure Search Console and Webmaster."],
                ["Do you build devices on Arduino?", "Yes. We develop and program devices on Arduino and ESP32: sensors, relay and equipment control, data sent to a server and alerts in Telegram."],
                ["Do you provide support after launch?", "Yes. We support websites, software and servers: fixing bugs, making backups and extending the system for new tasks."],
            ],
        },

        contact: {
            eyebrow: "Request",
            title: "Tell us about your task, and we'll suggest a solution",
            text: "Describe what you need. We'll get in touch during business hours, clarify the details and give you the timeline and cost.",
            labels: { name: "Your name", phone: "Phone", service: "Service", message: "Briefly about the task" },
            placeholders: { name: "How should we address you", phone: "+998 __ ___ __ __", message: "For example: I need a website with a catalog and requests sent to Telegram" },
            other: "Other",
            send: "Send request",
            sending: "Sending…",
            consent: "By clicking the button, you agree to the processing of your personal data.",
            successTitle: "Request sent!",
            successText: "We'll contact you during business hours.",
            again: "Send another one",
            error: "Couldn't send. Please call us: +998 93 099 60 60",
            phoneTitle: "Phone",
            emailTitle: "Email",
            addressTitle: "Address",
            addressValue: "Nukus, Republic of Karakalpakstan",
            hours: "Working hours",
            days: [["Mon–Fri", "09:00–18:00"], ["Sat", "09:00–12:30"], ["Sun", "Closed"]],
        },

        footer: {
            about: "An IT studio from Nukus: websites, software, CRM/ERP, integrations, Telegram bots and AI for business.",
            services: "Services",
            more: "More",
            regions: "Regions",
            company: "Company",
            gps: "GPS tracking & cameras",
            copy: "ALL SYSTEMS. All rights reserved.",
        },
    },
};

export default T;
